const copy = {
  backToHome: "Back to home page",
  translationCallout: {
    description:
      "The Subject and Description fields of this ticket were translated because our support agents currently can only provide support in English.",
  },
  unauthorizedPrompt: {
    ungated: {
      heading: "You haven't logged in yet.",
      description:
        "Submit a ticket is only available for paid support plans. Please login to verify your plan. If you are having trouble logging in, please go to the Help Center Assistant.",
      actions: {
        primary: "Login",
        goToHCA: "Go to Help Center Assistant",
      },
    },
    gated: {
      heading: "You do not have access to submit a ticket.",
      description:
        "Submit a ticket is only available for paid support plans.  To view this page, please click ‘Explore plans’ to upgrade your plan.  Otherwise, go to the Help Center Assistant page for support.",
      actions: {
        primary: "Explore plans",
        goToHCA: "Go to Help Center Assistant",
      },
    },
  },
  successDetails: {
    callout: {
      description: "Please check your email inbox for further instructions",
    },
    labels: {
      attachments: "Attachments",
      comment: "Description",
      email: "Email address",
      id: "Ticket ID#",
      priorityLevel: "Business impact",
      subject: "Subject",
    },
    title: "Your ticket has been submitted!",
  },
  errors: {
    page: {
      heading: "Looks like something isn't working",
      description: "Something went wrong. Try again later.",
      log: "Unable to load Ticket Submission due to priority level and/or CSRF error",
    },
    submission: "Something went wrong with ticket submission. Try again later.",
  },
};

export default copy;
